"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const common_utils_1 = require("@as-react/common-utils");
const react_1 = require("react");
const server_1 = require("react-dom/server");
const history_1 = require("history");
const hypernova = require("@as/hypernova");
const wrappers_1 = require("../wrappers");
const utils_1 = require("./utils");
const reduxAndTranslationRenderServer = (hypernovaRenderData, reactComponent, storeConfigurator, i18nTranslationResourceDataOnly, numeralInstance, i18nInstance, loggerInstance) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const requestedLanguage = hypernovaRenderData.context.aemConfiguration.translationLang;
    const requestedLocale = hypernovaRenderData.context.aemConfiguration.locale;
    const dynamicStore = new common_utils_1.DynamicStore();
    const i18nTranslationResources = {
        language: requestedLanguage,
        translationResources: i18nTranslationResourceDataOnly.translationResources,
    };
    yield i18nInstance.changeLanguage(requestedLanguage);
    loggerInstance.debug(`[reduxAndTranslationRenderServer] ${reactComponent.componentName} - i18nInstance language: ${i18nTranslationResources.language} - requested language: ${requestedLanguage}`);
    loggerInstance.debug(`[reduxAndTranslationRenderServer] ${reactComponent.componentName} - i18nTranslationResources language: ${i18nTranslationResources.language} - change success: ${i18nTranslationResources.language === requestedLanguage}`);
    numeralInstance.changeLocal(requestedLocale);
    const reactComponentPromised = yield reactComponent.promisedComponent();
    const hypernovaTransportableDataObject = (0, wrappers_1.generateHypernovaRenderingObject)(hypernovaRenderData, i18nTranslationResources);
    const getStore = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!reactComponent.hasReduxModule) {
            return;
        }
        const componentReduxModule = yield storeConfigurator.loadFromModuleCollection(reactComponent.componentName, (_a = hypernovaRenderData.store) !== null && _a !== void 0 ? _a : {});
        const routerHistory = componentReduxModule.hasRouter ? (0, history_1.createMemoryHistory)() : undefined;
        return storeConfigurator.buildDynamic((_b = hypernovaTransportableDataObject.store) !== null && _b !== void 0 ? _b : {}, hypernovaTransportableDataObject.context, dynamicStore, componentReduxModule.modules, componentReduxModule.hasRouter ? routerHistory : undefined);
    });
    const store = yield getStore();
    const possibleWrappers = (0, utils_1.generatedNeededServerSideWrapperComponents)(hypernovaTransportableDataObject, store);
    const wrappedComponent = possibleWrappers.reduce((componentSoFar, { wrapper, additionalWrapperArguments }) => {
        return wrapper(componentSoFar, additionalWrapperArguments);
    }, reactComponentPromised.default);
    const contents = (0, server_1.renderToString)((0, react_1.createElement)(wrappedComponent));
    return hypernova.serialize(reactComponent.componentName, contents, (0, wrappers_1.generateHypernovaTransportableObject)(hypernovaTransportableDataObject));
});
exports.default = reduxAndTranslationRenderServer;
//# sourceMappingURL=reduxAndTranslation.rendererServer.js.map